import { ChipGroup, type Option } from '@storeblocks/chip';
import { type FC } from 'react';

import { WithGap } from '@/components/WithGap';
import { TrackingElement, useGetTrackId } from '@/tracking';
import { CurrencyCode } from '@/types/CurrencyCode';

interface Props {
  currency: CurrencyCode;
  currencies: CurrencyCode[];
  label?: string;
  onChange: (currency: CurrencyCode) => void;
}

export const CurrencyChips: FC<Props> = ({
  currency,
  currencies,
  label,
  onChange,
}) => {
  const getTrackId = useGetTrackId();
  const trackId = getTrackId('select-value-type', TrackingElement.FilterChip);

  const options: Option[] = currencies.map((currency) => ({
    id: currency,
    label: currency,
    value: currency,
    inputProps: {
      'data-trackid': trackId,
      'data-trackid-selected-filter': currency,
      'data-trackid-source': 'fund-esg',
      'data-trackid-type': 'filter-chips',
    },
  }));

  const handleOnChange = (checked: string[]): void => {
    onChange(checked[0] as CurrencyCode);
  };

  return (
    <WithGap gap="8">
      <label
        className="font-body-demibold"
        id="currency-selector-fund-esg-label"
      >
        {label}
      </label>
      <ChipGroup
        chipVariant="choice"
        id="currency-selector-fund-esg"
        aria-labelledby="currency-selector-fund-esg-label"
        checked={[currency]}
        options={options}
        onChange={handleOnChange}
      />
    </WithGap>
  );
};
